import React, { FC } from 'react';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';

interface JobDetailsJobsDocumentsProps {
  jobId: number | null;
}

const JobDetailsJobsDocumentsComponent: FC<JobDetailsJobsDocumentsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  jobId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  return (
    <JobContentWrapper loading={false} title={title.job}>
      {jobId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={jobId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation} />
        </View>
      )}
    </JobContentWrapper>
  );
};

const JobDetailsJobsDocuments = connect(({ details: { jobId } }) => ({ jobId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsJobsDocumentsComponent);

export { JobDetailsJobsDocuments };
